import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dot-on",
  "use": "icon-dot-on-usage",
  "viewBox": "0 0 4 4",
  "content": "<symbol viewBox=\"0 0 4 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dot-on\">\n<circle cx=\"2\" cy=\"2\" r=\"2\" fill=\"#2F54EB\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol